/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  toggleAccordionMainBox: {
    background: theme.palette.secondary.contrastText,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  toggleAccordionRoot: {
    boxShadow: 'none',
    margin: '0 !important',
    width: '100%',

    '& .Mui-expanded': {
      minHeight: 'unset !important',
      margin: '0 !important',
      borderRadius: '0',
    },
    '& .MuiCollapse-root': {
      textAlign: 'center',
    },
    [theme.breakpoints.up('sm')]: {
      width: '18.25rem',
      top: '-2.4rem',
      height: '38px',
    },
  },
  fadedContainer: {
    zIndex: 1,
  },
  toggleAccordionSummaryRoot: {
    background: theme.palette.primary.backgroundColor4,
    borderRadius: '0 0 10px 10px',
    padding: '0.5rem',
    minHeight: '2.5rem',
    columnGap: '0.625rem',
    color: theme.palette.primary.textColor3,

    '& .MuiAccordionSummary-content': {
      color: theme.palette.primary.contrastText,
      flexGrow: '0',
      margin: '0',
    },
  },
  expandMoreIcon: {
    color: theme.palette.primary.textColor3,
  },
  toggleAccordionContent: {
    cursor: 'pointer',
    padding: '0.4375rem',
    color: theme.palette.primary.textColor5,
    borderRadius: '0 0 10px 10px',
    boxShadow: `0px 5px 5px -3px  ${theme.palette.primary.boxShadow2Dark}, 0px 8px 10px 1px  ${theme.palette.primary.boxShadow2Medium}, 0px 3px 14px 2px  ${theme.palette.primary.boxShadow2Lite}`,

    background: theme.palette.primary.backgroundColor2,
    ':hover': {
      background: theme.palette.primary.backgroundColor5,
      color: theme.palette.primary.textColor3,
    },
  },
});

export default styles;
